import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Person } from './person';

@inheritSerialization(AbstractModel)
export class ProviderDispatcher extends AbstractModel {
  @autoserialize
  providerId: number;

  @autoserializeAs(Person)
  person: Person;

  static OnSerialized(instance: ProviderDispatcher, json: any): void {
    super.OnSerialized(instance, json);
  }

  static OnDeserialized(instance: ProviderDispatcher, json: any): void {
    super.OnDeserialized(instance, json);
  }
}
